import { RouterProvider, createRouter } from "@tanstack/react-router";

import { useAccount } from "./Components/Account/AccountProvider";
import { routeTree } from "./routeTree.gen";

// Create a new router instance
const router = createRouter({
	routeTree,
	context: {
		account: undefined!,
	},
});

// Register the router instance for type safety
declare module "@tanstack/react-router" {
	interface Register {
		router: typeof router;
	}
}

export const Router = () => {
	const account = useAccount();
	return <RouterProvider router={router} context={{ account }} />;
};
